class SiteLinksService {

    /*@ngInject*/
    constructor($window) {

        this.ssRoute = $window.ssRoute ? $window.ssRoute : '/bathrooms/cart';
        this.continueShoppingLink = '/bathrooms/products';
        this.viewPreviousOrdersLink =  this.ssRoute +'/orders';
        this.checkoutLink = this.ssRoute + '/checkout';
        this.viewCartLink = this.ssRoute;
    }

    printPdfUrl(orderId) {
        // go to http URL
        return '/bathrooms/cart/secure/service/orders/'+orderId+'/print/online_order_'+orderId+'.pdf';

    }

    branchDetailsUrl(branchNumber) {
        return '/storefinder/' + branchNumber;
    }

    myQuotesUrl(quoteId) {
        return '/bathrooms/my-quotes/detail/' + quoteId;
    }
}

export default SiteLinksService;



// WEBPACK FOOTER //
// ./src/app/services/site-links-service.js